export default "__VITE_ASSET__CJ2CkvMO__"